import { Button } from "@atoms/index"

import styles from "./ButtonCell.module.scss"
import { ButtonCellProps } from "./ButtonCell.types"

function ButtonCell(props: ButtonCellProps) {
    const { variant = "subtle", ...rest } = props

    // The wrapper shields the button from the table's row-level click handler, so pressing
    // the action never doubles as a row navigation.
    const stopRowClick = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation()
    }

    return (
        <div className={styles.base} onClick={stopRowClick} onKeyDown={stopRowClick} role="presentation">
            <Button {...rest} type="button" variant={variant} size="sm" />
        </div>
    )
}

export default ButtonCell
